import React, { useState } from "react";
import api from "@/services/api";
import { toast } from "sonner";
import { Crown, Search, Loader2, Gift, CheckCircle2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function VendedorClub() {
  const [codigo, setCodigo] = useState("");
  const [beneficio, setBeneficio] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [redimiendo, setRedimiendo] = useState(false);

  const validar = async (e) => {
    e.preventDefault();
    if (!codigo.trim()) return;
    setCargando(true);
    setBeneficio(null);
    try {
      const r = await api.get(`/club/vendedor/validar/${encodeURIComponent(codigo.trim())}`);
      setBeneficio(r.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Código no encontrado");
    } finally {
      setCargando(false);
    }
  };

  const redimir = async () => {
    setRedimiendo(true);
    try {
      const r = await api.post(`/club/vendedor/redimir/${encodeURIComponent(beneficio.codigo)}`);
      toast.success(r.data.mensaje);
      setBeneficio({ ...beneficio, estado: "redimido" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo redimir");
    } finally {
      setRedimiendo(false);
    }
  };

  return (
    <div className="space-y-6 max-w-lg" data-testid="vendedor-club-page">
      <div>
        <h1 className="font-display text-3xl text-torta-dark flex items-center gap-2"><Crown className="w-7 h-7 text-amber-500" /> Club de la Abuela</h1>
        <p className="text-torta-muted text-sm">Valida y redime los códigos de beneficio de tus clientes (ABU-XXXX)</p>
      </div>

      <form onSubmit={validar} className="flex gap-2">
        <input
          data-testid="club-codigo-input"
          className="flex-1 px-4 py-3 rounded-xl border border-torta-sand text-torta-dark font-bold uppercase tracking-wider focus:outline-none focus:ring-2 focus:ring-torta-brown/40"
          placeholder="ABU-XXXX"
          value={codigo}
          onChange={(e) => setCodigo(e.target.value.toUpperCase())}
        />
        <button type="submit" data-testid="club-validar-btn" disabled={cargando}
          className="bg-torta-brown hover:bg-torta-brown/90 text-white font-semibold px-5 rounded-xl flex items-center gap-2 disabled:opacity-60">
          {cargando ? <Loader2 className="w-4 h-4 animate-spin" /> : <Search className="w-4 h-4" />} Validar
        </button>
      </form>

      {beneficio && (
        <div className="bg-white rounded-2xl shadow-sm p-5 space-y-3" data-testid="club-beneficio-resultado">
          <div className="flex items-center justify-between">
            <p className="font-bold text-torta-dark text-lg">{beneficio.codigo}</p>
            <Badge className={`border-0 ${beneficio.estado === "disponible" ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-600"}`}>
              {beneficio.estado.toUpperCase()}
            </Badge>
          </div>
          <div className="bg-torta-cream/50 rounded-xl p-4 space-y-1 text-sm">
            <p className="flex items-center gap-2 text-torta-dark"><Gift className="w-4 h-4 text-torta-brown" /> <strong>{beneficio.recompensa}</strong></p>
            <p className="text-torta-muted text-xs">Cliente: {beneficio.nombre_pila || "—"} · Nivel: {beneficio.nivel}</p>
            {beneficio.compra_minima > 0 && <p className="text-amber-700 text-xs">⚠️ Aplica para compras desde ${Number(beneficio.compra_minima).toLocaleString("es-CO")}</p>}
            {beneficio.fecha_vencimiento && <p className="text-torta-muted text-xs">Vence: {beneficio.fecha_vencimiento.slice(0, 10)}</p>}
          </div>
          {beneficio.estado === "disponible" ? (
            <button data-testid="club-redimir-btn" onClick={redimir} disabled={redimiendo}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 rounded-xl flex items-center justify-center gap-2 disabled:opacity-60">
              {redimiendo ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle2 className="w-4 h-4" />}
              Redimir y entregar al cliente
            </button>
          ) : (
            <p className="text-center text-sm text-torta-muted">Este código no está disponible para redimir.</p>
          )}
        </div>
      )}

      <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 text-xs text-amber-800">
        💡 El cliente ve su código en barujshefa.com/club con su celular. Al redimir aquí, entrégale la recompensa en el momento. La redención queda registrada a tu nombre.
      </div>
    </div>
  );
}
